var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{style:({ fontSize: _vm.fonts.font30 + 'px' })},[_vm._v("Disable Access to Account "+_vm._s(_vm.member.acct))]),_vm._v(" "),_c('sendPin',{attrs:{"optType":"unAuth","acct":_vm.member.acct,"type":"De-Authorization","opt1":"Deactivate only this device","opt2":"Deactivate ALL devices","opt3":"","opt4":""}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a057362","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/z-unAuth.vue
// module id = null
// module chunks = 